import { render, staticRenderFns } from "./Create.vue?vue&type=template&id=7002569a&lang=pug&"
import script from "./Create.vue?vue&type=script&lang=ts&"
export * from "./Create.vue?vue&type=script&lang=ts&"
import style0 from "./Create.vue?vue&type=style&index=0&id=7002569a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports